export default __webpack_public_path__ + "static/media/nike.4f26c393.png";